import { parse } from 'cookie';
import { GetServerSideProps } from 'next';
import { getAvailablePremiumLookupKeys } from '@app/common';

export const CAMPAIGN_OFFER_COOKIE = 'campaign_offer';

export const getAvailablePremiumLookupKeysFromCookie = (cookieHeader?: string): string[] => {
    const cookies = parse(cookieHeader ?? '');
    const publicKeys = getAvailablePremiumLookupKeys(cookies.affiliate);
    if (!cookies.campaign_id || !cookies[CAMPAIGN_OFFER_COOKIE]) return publicKeys;

    // This snapshot only controls the UI. Checkout validates the current campaign in the database.
    try {
        const offer = JSON.parse(cookies[CAMPAIGN_OFFER_COOKIE]);
        if (offer?.campaignId !== cookies.campaign_id || !Array.isArray(offer.allowedLookupKeys)) return publicKeys;
        const allowedKeys = publicKeys.filter((key) => offer.allowedLookupKeys.includes(key));
        return allowedKeys.length > 0 ? allowedKeys : publicKeys;
    } catch {
        return publicKeys;
    }
};

export const getPricingOfferServerSideProps: GetServerSideProps = async (context) => ({
    props: {
        initialData: {
            availablePremiumLookupKeys: getAvailablePremiumLookupKeysFromCookie(context.req.headers.cookie),
        },
    },
});
